




import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "./mixins";

@Component
export default class LazyLoader extends Mixins(ModelEditableMixin) {
  @Prop()
  objects: any[]; // 汎用的に使えるようにany.

  @Prop()
  initialLoadCount: number;

  @Prop()
  countPerLoad: number;

  @Prop()
  intervalAsMsec: number;

  data() {
    return {
      isLoading: false,
    };
  }
  isLoading: boolean;

  get objectCount(): number {
    return this.objects ? this.objects.length : 0;
  }

  get loadedObjectCount(): number {
    return Math.min(this.editingSource ? this.editingSource.length : 0, this.objectCount);
  }

  set loadedObjectCount(value: number) {
    const count = (this.objectCount < value) ? this.objectCount : value;
    this.editingSource = (this.objects ? this.objects : []).slice(0, count);
  }

  @Watch("objects")
  onObjectsUpdated() {
    // オブジェクトの追加/更新削除でも更新しないとダメ.
    this.loadedObjectCount = Math.min(this.loadedObjectCount, this.objectCount);
  }

  created(): void {
    this.restart();
  }

  restart(): void {
    this.loadedObjectCount = 0; // initialLoadCountの適用はloadNextで必要に応じて行う.
  }

  loadNext(): void {
    if (this.isLoading) {
      return;
    }
    if ((0 < this.objectCount) && (this.loadedObjectCount === 0)) {
      this.loadedObjectCount = Math.min(this.initialLoadCount, this.objectCount);
      return;
    }
    this.isLoading = true;
    setTimeout(() => {
      this.countUp();
      this.isLoading = false;
    }, this.intervalAsMsec);
  }

  countUp(): void {
    if (this.loadedObjectCount < this.objectCount) {
      this.loadedObjectCount = Math.min(this.loadedObjectCount + this.countPerLoad, this.objectCount);
    }
  }
}
